module.exports = __webpack_public_path__ + "static/media/bold.38a6d777.svg";